<ion-content>
  <ion-row>
    <ion-col class="left-hand-detail">
      <ng-container>
        <app-patient-summary-widget [patient]="patient"> </app-patient-summary-widget>
      </ng-container>
      <app-patient-notes [patient]="patient"> </app-patient-notes>
      <app-patient-history-listing
        *ngIf="patient.patientCalls && patient.patientNotifications"
        [patient]="patient"
        [user]="user"
        [patientCalls]="patient.patientCalls"
        [patientNotifications]="patient.patientNotifications"
      >
      </app-patient-history-listing>
    </ion-col>

    <ion-col id="patient-detail-review-top" class="right-hand-detail">
      <div *ngIf="isFollowupLocked" class="followup-lock-message">
        {{ followupLockMessage }}
      </div>
      <div class="followup-controls" [class.locked]="isFollowupLocked" [attr.aria-disabled]="isFollowupLocked">
        <ng-container *ngIf="patientCall$ | async">
          <div *ngIf="showPatientCallStatusValidation" class="patient-call-status-validation" role="alert" aria-live="polite">
            Please select a call status before stopping the call.
          </div>
          <div
            id="patient-call-status-field"
            class="patient-call-status-field"
            [class.has-validation-error]="showPatientCallStatusValidation"
          >
            <app-patient-call-status-controls
              [patientCall]="patientCall"
              [disabled]="isFollowupLocked"
              (patientCallStatusChangeEmitter)="patientCallStatusLabelChangeHandler($event)"
              (patientFinalCallStatusChangeEmitter)="patientFinalCallChangeHandler($event)"
            >
            </app-patient-call-status-controls>
          </div>
          <!-- this will be hidden if we have advanced past ID 3, which is the "started" state, but hide if it is the final call -->
          <app-patient-call-start-button
            *ngIf="
              patientCallStatuses[patientCall.patientCallStatusLabelId] < 3 &&
              patientCall.patientCallStatusLabel != 'Final Call'
            "
            [user]="user"
            [patientCall]="patientCall"
            [disabled]="isFollowupLocked"
            (patientCallStartEventEmitter)="patientCallStartEventHandler($event)"
          >
          </app-patient-call-start-button>

          <!-- Hide our questions once we are in call status Review or Greater -->
          <app-patient-call-questions
            *ngIf="
              (patient.patientCalls && patientCall.patientCallStatusLabel == 'Started') ||
              patientCall.patientCallStatusLabel == 'User Selected Status'
            "
            [patientCall]="patientCall"
            [lastCall]="patient.patientCalls[0]"
            (patientCallAnwersChangeEmitter)="patientCallQuestionsChangeHandler($event)"
          >
          </app-patient-call-questions>
          <app-patient-call-notes
            *ngIf="
              patientCall.patientCallStatusLabel == 'Started' ||
              patientCall.patientCallStatusLabel == 'In Review' ||
              patientCall.patientCallStatusLabel == 'User Selected Status' ||
              patientCall.patientCallStatusLabel == 'Final Call'
            "
            [patientCall]="patientCall"
            (patientCallNotesChangeEmitter)="patientCallNotesChangeHandler($event)"
            (patientCallNotesHighlightedChangeEmitter)="patientCallNotesHighlightedChangeHandler($event)"
          >
          </app-patient-call-notes>

          <app-patient-call-stop-button
            [patientCall]="patientCall"
            [disabled]="isFollowupLocked"
            *ngIf="
              patientCall.patientCallStatusLabel == 'Started' ||
              patientCall.patientCallStatusLabel == 'User Selected Status'
            "
            (patientCallEndEventEmitter)="patientCallEndEventHandler($event)"
          >
          </app-patient-call-stop-button>
          <ng-container *ngIf="patientCall.patientCallStatusLabel == 'In Review' && !patientCall.finalCall">
            <app-patient-next-call-scheduler
              (patientNextCallDateSelectedEventEmitter)="patientNextCallDateSelectedEventHandler($event)"
            >
            </app-patient-next-call-scheduler>

            <app-patient-next-call-finish-button
              *ngIf="patientCall.patientCallStatusLabel == 'In Review'"
              [patient]="patient"
              [patientCall]="patientCall"
              [disabled]="isFollowupLocked"
              (patientCallFinalizeEventEmitter)="patientCallFinishEventHandler(patientCall)"
            >
              Save
            </app-patient-next-call-finish-button>
          </ng-container>
          <ng-container *ngIf="patientCall.finalCall && patientCall.patientCallStatusLabel == 'In Review'">
            <app-followup-complete-button
              class="ion-float-right"
              *ngIf="patient"
              [patient]="patient"
              [patientCall]="patientCall"
              [disabled]="isFollowupLocked"
              (patientCallFinalizeEventEmitter)="patientCallFinishEventHandler(patientCall)"
            >
            </app-followup-complete-button>
          </ng-container>
        </ng-container>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
